<template>
  <v-card :color="color" class="pa-4" dark>
    <div class="d-flex align-center justify-space-between">
      <div>
        <div class="subtitle-2 text-uppercase mb-1">{{ title }}</div>
        <div class="text-h4 font-weight-bold">{{ value }}</div>
        <div v-if="caption" class="caption mt-1">{{ caption }}</div>
      </div>
      <v-icon x-large>{{ icon }}</v-icon>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'StatsCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    caption: {
      type: String,
      default: '',
    },
  },
}
</script>
